module.exports = __webpack_public_path__ + "static/media/interview.b16ada0c.png";